import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NAV_DROPDOWN_DIRECTIVES } from '../shared/nav-dropdown.directive';
import { User, Puser, Patient } from '../shared/models';
import { environment } from '../shared/config/app-config';
import { UserService, PatientService } from '../shared/services';
import { FormSessionCanDeactivate } from '../shared';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-dashboard',
  templateUrl: './full-layout.component.html',
  styleUrls: ['./assets/style.css']
})
export class FullLayoutComponent extends FormSessionCanDeactivate {
  cid: any;
  menuapp: any;
  resp: Puser;
  menu: any;
  menustatus: any = {};
  contactusVisible: boolean = false;
  userSubscription: Subscription;
  constructor(

    private router: Router,
    private userService: UserService,
    private patientservice: PatientService,
    private translate: TranslateService
  ) {
    super();
    this.translate.setDefaultLang(userService.defaultLang); 
  }

  currentUser: User;
  public apiurl: any = environment.api_url;
  public disabled = false;
  public status: { isopen: boolean } = { isopen: false };
  public toggled(open: boolean): void {

  }

  public toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.status.isopen = !this.status.isopen;
  }

  ngOnInit(): void {
    this.userSubscription = this.userService.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
        if (this.currentUser.item) {
          if (window.localStorage['ccdetails']) {
            let ccdetails = JSON.parse(atob(window.localStorage['ccdetails']))
            this.cid = ccdetails.cnuseraccid
          } else {
            this.cid = this.currentUser.item.userAccountId
          }
        }
        this.getmsgcount()
        this.getmenu()
        this.unReadTotalDocumentsCount()
      }
    )



  }
  getmsgcount() {
    if (this.cid && this.currentUser.item) {
      try {
        this.userService.msgcountPP(this.cid)
          .subscribe(
            data => {
              this.currentUser.item.msgcount = data.UnReadTotalMsgCount
              this.userService.currentUserSubject.next(this.currentUser);
            })
      } catch (error) {

      }
    }
  }
  getmenu() {
    try {
      if (this.currentUser.item) {        
        this.userService.postuserinfoid('1', this.currentUser.item.userAccountId)
          .subscribe(
            data => {
              this.menu = data[1].menu;
              var clientId = data[0]              
              window.localStorage.setItem('WFD',btoa(clientId.patientStageWorkflow[0].clientId))
              if (this.menu) {
                for (var i = 0; i < this.menu.length; i++) {
                  if (this.menu[i].refName == 'PAT_MESSAGES') {
                    this.menustatus.message = this.menu[i].status

                  }
                  else if (this.menu[i].refName == 'PAT_APPOINTMENTS') {
                    this.menustatus.appoinment = this.menu[i].status
                  }
                  else if (this.menu[i].refName == 'DOCUMENT_ALL') {
                    this.menustatus.document = this.menu[i].status
                  } else if (this.menu[i].refName == 'CONTACT ME') {
                    this.contactusVisible = this.menu[i].status;
                  }
                  else if (this.menu[i].refName == 'PAT_EXCERCISE') {
                    this.menustatus.exercisevideo = this.menu[i].status;
                  }
                  else if (this.menu[i].menuId == 20) {
                    this.menustatus.documents = this.menu[i].status;
                  }

                }




              }

            })
      }
    } catch (error) {

    }
  }

  unReadTotalDocumentsCount()
  {

    this.userService.unReadTotalDocumentsCount(this.cid)
    .subscribe(
      data => {
        this.currentUser.item.documentCount = data.UnReadTotalDocCount
        this.userService.currentUserSubject.next(this.currentUser);
      })
  }

  ngOnDestroy() {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }
}